import React from 'react'

const CheckIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 17 17">
      <path d="M8.5,0C3.8,0,0,3.8,0,8.5s3.8,8.5,8.5,8.5,8.5-3.8,8.5-8.5S13.2,0,8.5,0ZM7.2,13l-4.2-3.7,1.4-1.2,2.8,2.5,6.3-5.5,1.4,1.2-7.8,6.8Z" />
    </svg>
  )
}
export default CheckIcon
